import Hours from './Hours';

export default Hours;
